import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';
import { SendMoneyService } from '../send-money.service';
import {DomSanitizer} from '@angular/platform-browser';

declare var webengage
@Component({
  selector: 'app-step5',
  templateUrl: './step5.component.html',
  styleUrls: ['./step5.component.scss']
})
export class Step5Component implements OnInit, OnDestroy {
  loading=true
  isSuccessful=false
  trans_key
  recvName
  payment_source_success = false
  pdfUrl
  constructor(public sendMoneyService:SendMoneyService,public router:Router,private activatedRoute: ActivatedRoute,private messageService: MessageService,public auth:AuthService, public common:CommonService, public sanitizer : DomSanitizer) { }

  ngOnInit(): void {
    if(this.auth.user.country_id==233){
      let url = 
      this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.api_link}/transaction/${this.sendMoneyService.usa_trans_details.id}`)
      this.pdfUrl = url
    }
    
    this.common.stopLoader()
    this.trans_key=this.activatedRoute.snapshot.paramMap.get("trans_key")
    //console.log(this.activatedRoute.snapshot.paramMap)
    this.activatedRoute.queryParams.subscribe(params => {
      this.payment_source_success =  params['payment-source-qr']
      webengage.track("confirm_and_pay",{
        "Status" : "success"
      })
    })
    if(this.trans_key){
      webengage.track("confirm_and_pay",{
        "Status" : "success"
      })
      this.loading=false
    }

/*     if(!(this.sendMoneyService.purpose && this.sendMoneyService.receiver && this.sendMoneyService.transactionDetails && this.sendMoneyService.fundingSource)){
      this.router.navigateByUrl("/send-money/step1")
    } */
    this.sendMoneyService.isMarkComplete=true
    this.sendMoneyService.isMarkConfirm=true
    this.sendMoneyService.isMarkTransaction=true
    this.sendMoneyService.isMarkPurpose=true
    if(this.auth.user.country_id==39){
      this.sendMoneyService.confirmScreen=true
      this.activatedRoute.queryParams.subscribe(params => {
        //console.log(params)
        //error = Unsuccessful
        //success = Successful
        if(params['success'] && params['success']=="Successful"){
          webengage.track("confirm_and_pay",{
            "Status" : "success"
          })
          this.recvName = localStorage.getItem('recvName')
          this.isSuccessful=true
          this.loading=false
          localStorage.removeItem('customerRefNo')
          localStorage.removeItem('recvName')
          if(localStorage.getItem('cc')){
            this.sendMoneyService.usedCoupon(localStorage.getItem('cc'), this.auth.user.id).subscribe(res => {
              //console.log(res)
              localStorage.removeItem('cc')
            })
          } 
          

        } 
        else if(params['error'] && params['error'] == "Unsuccessful"){
          webengage.track("confirm_and_pay",{
            "Status" : "failure"
          })
          this.isSuccessful=false
          this.loading=false
          localStorage.removeItem('customerRefNo')
          localStorage.removeItem('recvName')


        } else if(params['error'] && params['error'] == "True"){
          webengage.track("confirm_and_pay",{
            "Status" : "failure"
          })
          this.isSuccessful=false
          this.loading=false
          let responsePSIData:any={
            // psi_approval:params['Approved'] == "APPROVED" ? "Successful" : "Unsucessful",
            customer_ref_no:localStorage.getItem('customerRefNo'),
            // psi_order_id:params['OrderID'],
            // psi_trans_ref_no:params['TransRefNumber'],
            payment_gateway_id:1,  //params['OrderID']g
            transaction_type : 'individual'
          }

          this.sendMoneyService.onPsiSuccessResult(responsePSIData).subscribe(res=>{
            this.isSuccessful=true
            this.loading=false
            localStorage.removeItem('customerRefNo')
            localStorage.removeItem('recvName')

          },err=>{
            this.isSuccessful=false
            localStorage.removeItem('customerRefNo')
            localStorage.removeItem('recvName')

          })

        }
        else{
          webengage.track("confirm_and_pay",{
            "Status" : "failure"
          })
          this.isSuccessful=false
          this.loading=false
        }
      });
    }else{
      this.recvName = localStorage.getItem('recvName')
      this.isSuccessful=this.sendMoneyService.success_usa
      this.loading=false
      localStorage.removeItem('recvName')
      webengage.track("confirm_and_pay",{
        "Status" : `${this.sendMoneyService.success_usa}?'success':'failure'`
      })
    }
    
  }

  goToHome(){
    localStorage.removeItem('recvName')
    this.sendMoneyService.usa_trans_details = ''
    this.sendMoneyService.confirmScreen=false
    this.router.navigateByUrl("/dashboard")
  }

  ngOnDestroy(){
    this.sendMoneyService.resetData()
  }
}





